// Fonctions utilitaires pour construire les URLs nécessaires.
// - buildOfferUrl: lien vers l'offre sur le site principal
// - buildRegisterUrl: lien de création de compte pré-rempli
// - buildAtsFormUrl: lien du formulaire ATS (avec jobId si présent)
import { atsFormUrl, backendUrl, offerPathTemplate, siteUrl } from "../config_prod";
import { Lang } from "../type/language";

export function buildOfferUrl(offerId: string | null): string {
  if (!offerId) return siteUrl;
  return siteUrl + offerPathTemplate.replace('{id}', offerId);
}

export function buildRegisterUrl(lang: Lang, name: string, email: string): string {
  try {
    const u = new URL(siteUrl);
    u.pathname = `/${lang}/register`;
    u.searchParams.set('email', email || '');
    u.searchParams.set('name', name || '');
    return u.toString();
  } catch {
    return `${siteUrl}/${lang}/register`;
  }
}

export function buildAtsFormUrl(offerId: string | null): string {
  if (!offerId) return atsFormUrl;
  const url = new URL(atsFormUrl);
  url.searchParams.set('jobId', offerId);
  return url.toString();
}

export function resolveLogoUrl(value?: string | null): string | null {
  const raw = String(value || '').trim();
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) return raw;
  if (raw.startsWith('//')) return `https:${raw}`;
  return `${backendUrl.replace(/\/+$/, '')}/${raw.replace(/^\/+/, '')}`;
}
